// chart data

import RevenueChartCardData from './revenue-chart';


// ==============================|| WIDGET - CHART DATA OBJECT ||============================== //

const chartData = {
  
    RevenueChartCardData,

  
};

export default chartData;
